<div class="appointment-page">
  <header class="page-header">
    <div class="header-content">
      <h2 class="display-xs-semibold text-gray-900 m-0">Nova rezervacija</h2>
      <span class="text-md-regular text-gray-600">Zakazivanje termina za klijenta</span>
    </div>
    <button type="button" class="close-btn" (click)="cancel()" aria-label="Zatvori">
      <app-x-close stroke="#181D27" width="12px" height="12px"></app-x-close>
    </button>
  </header>

  <div class="page-body">
    <form [formGroup]="form" class="form-content">
      <app-field label="Klijent" for="client-search">
        <div class="autocomplete-with-icon">
          <app-search class="input-icon" stroke="#ADB0B8"></app-search>
          <p-autocomplete
            [autofocus]="false"
            [showClear]="true"
            inputId="client-search"
            [(ngModel)]="clientModel"
            [ngModelOptions]="{ standalone: true }"
            [suggestions]="clientSuggestions()"
            [group]="true"
            optionLabel="name"
            optionGroupLabel="label"
            optionGroupChildren="items"
            placeholder="Pretražite klijenta"
            [forceSelection]="true"
            appendTo="body"
            styleClass="w-full"
            inputStyleClass="with-icon w-full"
            (completeMethod)="searchClients($event)"
            (onSelect)="onClientSelected($event)"
            (onClear)="resetClient()"
          >
            <ng-template let-group #group>
              <div class="client-group-header">{{ group.label }}</div>
            </ng-template>
            <ng-template let-item #item>
              <div class="client-item">
                <span class="text-md-medium text-gray-900">{{ item.name }}</span>
                <button
                  type="button"
                  class="client-item-action"
                  aria-label="Otvori klijenta"
                  (click)="openClientInfo(item, $event)"
                >
                  <app-link-external-02 stroke="#2970FF" width="1.0625rem" height="1.0625rem"></app-link-external-02>
                </button>
              </div>
            </ng-template>
          </p-autocomplete>
        </div>
      </app-field>

      @if (selectedClient(); as client) {
        <div class="client-card">
          <div class="client-card-left">
            <div class="client-card-icon">
              @if (client.isCompany) {
                <app-building-05 stroke="#181D27" width="1.25rem" height="1.25rem"></app-building-05>
              } @else {
                <app-user-circle stroke="#181D27" width="1.25rem" height="1.25rem"></app-user-circle>
              }
            </div>
            <div class="client-card-info">
              <span class="text-xs-regular text-gray-500">
                {{ client.isCompany ? 'PRAVNO LICE' : 'FIZIČKO LICE' }}
              </span>
              <span class="text-sm-semibold text-gray-900">{{ client.name }}</span>
            </div>
          </div>
          <div class="client-card-hours">
            <span class="text-xs-regular text-gray-500">PREOSTALO SATI</span>
            <span class="text-sm-semibold text-gray-900">{{ packageHours() }}h</span>
          </div>
        </div>

        @if (packageHours() === 0) {
          <div class="no-hours-message text-sm-regular text-gray-700">
            Klijent nema dovoljno sati za rezervaciju
          </div>
        } @else {
        <div class="form-field">
          <label class="text-sm-medium text-gray-700" for="duration">Trajanje termina</label>
          <app-dropdown
            formCtrlId="duration"
            optionLabel="label"
            optionValue="value"
            ctrlPlaceholder="Izaberite trajanje"
            [hasIcon]="true"
            [formCtrl]="durationCtrl"
            [options]="durationOptions()"
          >
            <app-hourglas-03 dropdownIcon stroke="#ADB0B8" width="20px" height="20px"></app-hourglas-03>
          </app-dropdown>
        </div>

        <div class="date-time-row">
          <div class="form-field date-col">
            <label class="text-sm-medium text-gray-700">Datum</label>
            <app-calendar
              [formCtrl]="dateCtrl"
              [inline]="true"
              [ctrlShowTime]="false"
              [hideErrors]="true"
              [minDateCtrl]="minDate()"
              [maxDateCtrl]="maxDate()"
              [unavailableDays]="disabledDates()"
            ></app-calendar>
          </div>

          <div class="form-field time-col">
            <label class="text-sm-medium text-gray-700">Vreme</label>
            @if (!dateCtrl.value) {
              <div class="time-empty text-sm-regular text-gray-500">Izaberite datum</div>
            } @else {
              <div class="time-slots">
                @for (interval of availableIntervals(); track interval.from) {
                  <button
                    type="button"
                    class="time-slot"
                    [class.selected]="isIntervalSelected(interval)"
                    (click)="selectInterval(interval)"
                  >
                    {{ formatTime(interval.from) }} - {{ formatTime(interval.to) }}
                  </button>
                }
              </div>
            }
          </div>
        </div>
        }
      }
    </form>
  </div>

  <footer class="page-footer">
    <app-button
      [btnSize]="ButtonSize.MD"
      [btnSeverity]="ButtonSeverity.SECONDARY"
      (btnClicked)="cancel()"
    >
      <div class="text-sm-semibold text-gray-900">Otkaži</div>
    </app-button>
    <app-button
      [btnSize]="ButtonSize.MD"
      [btnSeverity]="ButtonSeverity.PRIMARY"
      [isBtnDisabled]="!selectedClient() || packageHours() === 0 || form.invalid"
      (btnClicked)="submit()"
    >
      <div class="text-sm-semibold text-white">Potvrdi rezervaciju</div>
    </app-button>
  </footer>
</div>
